import {type GlobalState} from 'types/store';

export const getShouldAdminRefresh = (state: GlobalState) => state.adminUi.shouldRefresh;
